define("Magento_Ui/js/lib/knockout/bindings/mage-init",["ko","underscore","mage/apply/main"],(function(n,i,e){"use strict";n.bindingHandlers.mageInit={init:function(n,a){var t=a();i.each(t,(function(i,a){e.applyFor(n,i,a)}))}}}));
